import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Initialise Sentry only when a DSN is provided and we are not in dev mode.
// Errors-only setup (no tracing, no session replay) per user choice — keeps within
// the free Developer tier (5,000 errors/mo).
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN && process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,       // no performance monitoring
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Don't send PII by default; buyer emails etc are already visible on the backend.
    sendDefaultPii: false,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding:'2rem',fontFamily:'Georgia,serif',textAlign:'center',color:'#3D2817'}}>Qualcosa è andato storto. Ricarica la pagina.</div>}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
